'use strict';

/* Controllers */

angular.module('FlexyBeautyApp.controllers')
    .controller('LoginCtrl',['$rootScope', '$scope', '$location', '$window', '$routeParams', '$timeout', 'Auth', 'User', 'UserSrv','LanguageManager','gettextCatalog','Countries','LocaleList','CompanyType','Brand','Offers','OfferManager',
        function($rootScope, $scope, $location, $window, $routeParams, $timeout, Auth, User, UserSrv, LanguageManager, gettextCatalog, Countries, LocaleList, CompanyType, Brand, Offers, OfferManager)
        {
            //Language.init();
            gettextCatalog.debug = false;
            if(navigator.language.toLowerCase() === "en" || navigator.language.toLowerCase() === "en-gb") {
                LanguageManager.initLanguageManager("en-GB");
            }
            $scope.rememberme = true;
            $scope.processingLogin = false;
            $scope.processingRegister = false;

            $scope.alertsLogin = [];
            $scope.alertsRegister = [];
            $scope.displayErrorMessage = false;
            $scope.languages = [];
            $scope.currencies = [];
            $scope.companyTypes = CompanyType;

            $scope.showPassword = false;

            $scope.brand = Brand;
            $scope.offers = Offers;

            $scope.userLogin = {
                offer: ($routeParams.offer && $routeParams.offer !== '') ? $routeParams.offer : OfferManager.computeDefaultRegisterOfferCode(),
                firstName: "",
                lastName: "",
                phone: "",
                email: "",
                password: "",
                companyName: "",
                legalType: false,
                companyModel: "",
                localeCode : "fr-FR",
                currencyCode : "EUR",
                countryCode : "FR",
                companyDiscountCode: "",
                companyTypeId :  "",
                isModel: false,
                companyManager: ($routeParams.manager && $routeParams.manager != '') ? $routeParams.manager : null,
                role: Auth.userRoles.user
            };

            var path = $location.path();

            if(path.indexOf("model")!= -1){
                $scope.userLogin.isModel = true;
            }

            if ($routeParams.login != null && $routeParams.login != '') {
                //try to login
                var user = new User();
                user.email =  $routeParams.login;
                $scope.processingLogin = true;
                $scope.addAlertLogin = [];
                Auth.loginToProSiteFromMaster(user,
                    function(res) {
                        $scope.processingLogin = false;
                        var msg = gettextCatalog.getString("Connexion sécurisée établie");
                        $scope.addAlertLogin('success',msg);
                        $location.path('/');
                    },
                    function(errorMessage) {
                        $scope.addAlertLogin('error',errorMessage);
                        $scope.processingLogin = false;
                    });
            }

            $scope.getCountriesList = function() {
                return Countries.list;
            };

            $scope.getLocalesList = function() {
                return LocaleList;
            };

            $scope.getLocaleSeparator = function() {
                return LanguageManager.LOCALE_SEPARATOR;
            };

            $scope.toggleShowPassword = function() {
                $scope.showPassword = !$scope.showPassword;
            }

            $scope.ifSwitzerland = function() {
                if($scope.userLogin.countryCode === "CH"){
                    return true;
                }
                else {
                    return false;
                }
            };
            $scope.login = function() {
                $scope.alertsLogin = [];

                if ($scope.userLogin.email == "" || $scope.userLogin.password == "") {
                    var msg = gettextCatalog.getString("Merci de renseigner les champs obligatoires");
                    $scope.addAlertLogin('error',msg);
                    return;
                }
                let user = new User($scope.userLogin);
                $scope.processingLogin = true;

                Auth.loginToProSite(user,
                    function(res) {
                        $scope.processingLogin = false;
                        var absUrl = $location.absUrl();
                        if (absUrl.indexOf("/connect#/login")!=-1)
                            $window.open('/connect/'+user.companyCode, "_self");
                        else
                        {
                            var msg = gettextCatalog.getString("Connexion sécurisée établie");
                            $scope.addAlertLogin('success',msg);
                            $location.path('/');
                        }
                    },
                    function(errorMessage) {
                        $scope.addAlertLogin('error',errorMessage);
                        $scope.processingLogin = false;
                    });
            }

            $scope.register = function() {
                if ($scope.userLogin.email=="" || $scope.userLogin.companyName==""|| $scope.userLogin.companyTypeId==""
                    || $scope.userLogin.password=="" || $scope.userLogin.firstName==""|| $scope.userLogin.lastName==""|| ($scope.userLogin.phone=="" || $scope.userLogin.displayPhoneError)
                    || !$scope.userLogin.countryCode || !$scope.userLogin.currencyCode || !$scope.userLogin.localeCode)
                {
                    var msg = gettextCatalog.getString("Merci de renseigner les champs obligatoires");
                    $scope.addAlertRegister('error',msg);
                    return;
                }
                var user = new User($scope.userLogin);
                $scope.processingRegister = true;
                $scope.alerts = [];
                Auth.registerToProSite(user,function(res) {
                        var msg = gettextCatalog.getString("Compte créé avec succès");
                        $scope.addAlertRegister('success',msg);
                        $location.path('/');
                        $scope.processingRegister = false;
                    },
                    function(errorMessage) {
                        $scope.addAlertRegister('error',errorMessage);
                        $scope.processingRegister = false;
                    });
            }

            $scope.forgotPwd = function() {
                if ($scope.userLogin.email == "") {
                    var msg = gettextCatalog.getString("Merci de renseigner l'email");
                    $scope.addAlertLogin('error',msg);
                    return;
                }
                var user = new User($scope.userLogin);
                $scope.processingLogin = true;
                $scope.alertsLogin = [];
                UserSrv.forgotPwd(user,function(res) {
                        $scope.processingLogin = false;
                        var msg = gettextCatalog.getString("Un email permettant de réinitialiser votre mot de passe vous a été envoyé");
                        $scope.addAlertLogin('success',msg);
                    },
                    function(errorMessage) {
                        $scope.addAlertLogin('error',errorMessage);
                        $scope.processingLogin = false;
                    });
            }

            $scope.addAlertLogin = function(type, msg) {
                $scope.alertsLogin.push({type: type, msg: msg});
            };

            $scope.closeAlertLogin = function(index) {
                $scope.alertsLogin.splice(index, 1);
            };
            $scope.addAlertRegister = function(type, msg) {
                $scope.alertsRegister.push({type: type, msg: msg});
            };

            $scope.closeAlertRegister = function(index) {
                $scope.alertsRegister.splice(index, 1);
            };

        }
    ]);



// WEBPACK FOOTER //
// ./js/controllers/pro/LoginCtrl.js